/* Cledro homepage: hero slides, rotating lines, reviews, scroll reveals and the orange swirl.
   Every init is idempotent so the theme editor can reload single sections. */
(function(){
  if(window.CledroHome)return;
  var still=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('cl-js');
  function $$(sel,root){return [].slice.call((root||document).querySelectorAll(sel));}
  function once(el,key){if(el.dataset[key])return false;el.dataset[key]='1';return true;}

  // rotate .on through a list of elements, the old one leaves upward
  function cycle(items,ms,out){
    var i=0;if(items.length<2||still)return null;
    return setInterval(function(){
      var cur=items[i];cur.classList.remove('on');if(out)cur.classList.add('out');
      i=(i+1)%items.length;var nx=items[i];nx.classList.remove('out');nx.classList.add('on');
      if(out)setTimeout(function(){cur.classList.remove('out');},650);
    },ms);
  }

  // hero: the hero fills the screen below the header, each face sits at ~34% of the height
  function frame(img){
    var cw=img.clientWidth,ch=img.clientHeight,iw=img.naturalWidth,ih=img.naturalHeight;
    if(!cw||!ch||!iw)return;
    var s=Math.max(cw/iw,ch/ih),dh=ih*s;
    if(dh<=ch+1){img.style.objectPosition='50% 50%';return;}
    var top=ch*0.34-parseFloat(img.dataset.fy||0.4)*dh;
    top=Math.min(0,Math.max(ch-dh,top));
    img.style.objectPosition='50% '+(top/(ch-dh)*100).toFixed(1)+'%';
  }
  function heroOffset(){
    $$('.cl-hero').forEach(function(h){
      // the hero starts below the announcement bar and header, so it fills exactly the rest of the screen
      var off=Math.max(0,Math.round(h.getBoundingClientRect().top+scrollY));
      h.style.setProperty('--cl-hero-offset',off+'px');
      $$('img[data-fy]',h).forEach(frame);
    });
  }
  function initHero(h){
    if(!once(h,'clInit'))return;
    var slides=$$('.cl-slide',h),dots=$$('.cl-dots button',h),si=0,timer;
    function show(n){
      slides[si].classList.remove('on');
      si=(n+slides.length)%slides.length;
      slides[si].classList.add('on');
      dots.forEach(function(d,i){d.classList.remove('on','done');if(i<si)d.classList.add('done');});
      if(dots[si]){void dots[si].offsetWidth;dots[si].classList.add('on');}
      clearTimeout(timer);if(!still&&slides.length>1)timer=setTimeout(function(){show(si+1);},6000);
    }
    dots.forEach(function(d,i){d.addEventListener('click',function(){show(i);});});
    $$('img[data-fy]',h).forEach(function(img){if(img.complete)frame(img);else img.addEventListener('load',function(){frame(img);});});
    if(slides.length)show(0);
  }

  function initPrice(s){
    if(!once(s,'clInit'))return;
    cycle($$('.cl-pn',s),4200,false);
    cycle($$('.cl-rot span',s),2400,true);
  }

  function initReviews(s){
    if(!once(s,'clInit'))return;
    var rq=$$('.cl-rq',s),i=0,t,count=s.querySelector('[data-rev-count]'),stage=s.querySelector('.cl-rev-stage');
    if(!rq.length)return;
    function show(n){rq[i].classList.remove('on');i=(n+rq.length)%rq.length;rq[i].classList.add('on');if(count)count.textContent=(i+1)+' / '+rq.length;}
    function auto(){clearInterval(t);if(!still)t=setInterval(function(){show(i+1);},6000);}
    var p=s.querySelector('[data-rev-prev]'),n=s.querySelector('[data-rev-next]');
    if(p)p.addEventListener('click',function(){show(i-1);auto();});
    if(n)n.addEventListener('click',function(){show(i+1);auto();});
    if(stage){stage.addEventListener('mouseenter',function(){clearInterval(t);});stage.addEventListener('mouseleave',auto);}
    auto();
  }

  // reveal: only what starts below the fold is hidden, then it rises in with a small stagger
  var io=(!still&&'IntersectionObserver' in window)?new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('pre');io.unobserve(e.target);}});
  },{rootMargin:'0px 0px -6% 0px'}):null;
  function initReveal(root){
    if(!io||window.Shopify&&Shopify.designMode)return;
    $$('.cl-rv',root).forEach(function(el){
      if(!once(el,'clRv'))return;
      if(el.getBoundingClientRect().top>innerHeight*0.92){
        var sib=[].slice.call(el.parentElement.children).filter(function(c){return c.classList.contains('cl-rv');});
        el.style.setProperty('--d',Math.min(sib.indexOf(el),5)*90+'ms');
        el.classList.add('pre');io.observe(el);
      }
    });
  }

  // orange swirl: one wandering line from below the hero to the last homepage section, drawn while scrolling
  var svg,pth,lens=[],ys=[],total=0,drawn=0,goal=0,running=false;
  function buildSwirl(){
    var secs=$$('.cl');if(!secs.length){if(svg)svg.style.display='none';return;}
    var main=document.getElementById('MainContent')||document.body;
    if(!svg){
      svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('class','cl-swirl');svg.setAttribute('aria-hidden','true');
      pth=document.createElementNS('http://www.w3.org/2000/svg','path');svg.appendChild(pth);
      if(getComputedStyle(main).position==='static')main.style.position='relative';
      main.insertBefore(svg,main.firstChild);
    }
    svg.style.display='';
    var mTop=main.getBoundingClientRect().top+scrollY;
    var hero=document.querySelector('.cl-hero'),first=hero||secs[0],last=secs[secs.length-1];
    var fr=first.getBoundingClientRect(),lr=last.getBoundingClientRect();
    var y0=(hero?fr.bottom-40:fr.top+40)+scrollY-mTop,y1=lr.bottom+scrollY-mTop-20,W=main.clientWidth;
    if(y1-y0<300){svg.style.display='none';return;}
    svg.setAttribute('width',W);svg.setAttribute('height',y1+40);svg.style.height=(y1+40)+'px';svg.style.top='0px';
    // the vertical step shrinks with the screen width, so the loops still curl back up on a phone
    var r=Math.min(150,Math.max(46,W*0.14)),k=r/150,loopMax=Math.min(220,W*0.22);
    var T=(y1-y0)/r,d='',px=0,py=0;lens=[0];ys=[];total=0;
    for(var i=0;i<=T*24;i++){
      var t=i/24,u=t*k;
      var loop=Math.pow(Math.max(0,Math.sin(0.6*u+1.2)),6)*loopMax;
      var x=W*0.5+W*0.28*Math.sin(0.31*u)+loop*Math.cos(t);
      var y=y0+r*t-loop*0.9*Math.sin(t);
      if(i===0){d='M'+x.toFixed(1)+' '+y.toFixed(1);}else{d+=' L'+x.toFixed(1)+' '+y.toFixed(1);total+=Math.hypot(x-px,y-py);lens.push(total);}
      ys.push(y+mTop);px=x;py=y;
    }
    pth.setAttribute('d',d);pth.style.strokeDasharray=total;drawn=Math.min(drawn,total);drawSwirl();
  }
  function targetLen(){
    var target=scrollY+innerHeight*0.62,L=0;
    for(var i=0;i<ys.length;i++){if(ys[i]<=target)L=Math.max(L,lens[i]);}
    return L;
  }
  function tick(){
    drawn+=(goal-drawn)*0.08;
    if(Math.abs(goal-drawn)<0.5){drawn=goal;running=false;}
    pth.style.strokeDashoffset=Math.max(0,total-drawn);
    if(running)requestAnimationFrame(tick);
  }
  function drawSwirl(){
    if(!pth)return;
    if(still){pth.style.strokeDashoffset=0;return;}
    goal=targetLen();
    if(!running){running=true;requestAnimationFrame(tick);}
  }

  function init(root){
    root=root||document;
    $$('.cl-hero',root).forEach(initHero);
    $$('[data-cl-price]',root).forEach(initPrice);
    $$('[data-cl-reviews]',root).forEach(initReviews);
    initReveal(root);
    heroOffset();
  }
  var rs;
  function relayout(){clearTimeout(rs);rs=setTimeout(function(){heroOffset();buildSwirl();},200);}
  window.addEventListener('scroll',drawSwirl,{passive:true});
  window.addEventListener('resize',relayout);
  window.addEventListener('load',relayout);
  if('ResizeObserver' in window){new ResizeObserver(relayout).observe(document.body);}
  document.addEventListener('shopify:section:load',function(e){init(e.target);relayout();});
  document.addEventListener('shopify:section:unload',relayout);
  document.addEventListener('shopify:section:reorder',relayout);

  window.CledroHome={init:init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init();buildSwirl();});
  else{init();buildSwirl();}
})();
